import { Col, Layout, Radio, RadioChangeEvent, Row, Skeleton, Space } from "antd"
import { Content, Header } from "antd/es/layout/layout"
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { mdlKeyTitlePair } from "../../models/domain/value-objects/KeyTitlePair";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import { mdlAgencyMarketPairListRequest } from "../../models/service-models/agency-market/AgencyMarketPairListRequest";
import { MarketService } from "../../services/MarketService";
import { TransferDirection } from "antd/es/transfer";
import { mdlActionPricePairHolder } from "../../models/domain/value-objects/ActionPricePairHolder";
import { mdlServiceResponse } from "../../models/service-models/common/ServiceResponse";
import { mdlSpoOfferDetailResponse } from "../../models/service-models/action/SpoOfferDetailResponse";
import CustomTransfer from "../common/CustomTransfer";
import { Key } from "antd/es/table/interface";

export type ActionWizardFirstProps = {
    agencies?: mdlKeyTitlePair[];
    actionCreateRequestSetter: Function;
    actionPricePair: mdlActionPricePairHolder;
    marketAgencyPairSetter: Function;
    spoDetail?: mdlServiceResponse<mdlSpoOfferDetailResponse>;
    allMarkets?: boolean;
    isLoading?: boolean;
    clearAgencyMarketData: Function;
    parentChangeFunction: Function;
    parentChangeStatus: boolean;
}

export const ActionWizardFirst = (props: ActionWizardFirstProps) => {
    const { t } = useTranslation();
    const [marketFilterRequest, setMarketFilterRequest] = useState<mdlAgencyMarketPairListRequest>();

    useEffect(() => {
        if (props.allMarkets != undefined)
            setMarketFilterRequest({ allMarkets: props.allMarkets });
    }, [props.allMarkets])

    const {
        data,
        isLoading
    } = useQuery(
        ["getMarketAgencyFilter", props.allMarkets, marketFilterRequest?.allMarkets],
        () => {
            if (marketFilterRequest || props.allMarkets != null) {
                var mFilterRequest = marketFilterRequest ?? { allMarkets: props.allMarkets }
                return MarketService.AgencyMarketPairList(mFilterRequest);

            }
        },
        {
            onSuccess(data) {
                props.marketAgencyPairSetter(data?.body?.data);
            },
            refetchOnWindowFocus: false,
            enabled: !!marketFilterRequest
        }
    );

    const handleTransferChange = (
        targetKeys: Key[],
        direction: TransferDirection,
        moveKeys: Key[]
    ) => {
        const result = {
            ...props.actionPricePair,
            ["agencies"]: targetKeys.map(x => ({ title: x, key: x }))
        };
        props.actionCreateRequestSetter(result);
    }


    const handleTypeChange = (e: RadioChangeEvent) => {
        setMarketFilterRequest({ ...marketFilterRequest, ["allMarkets"]: e.target.value })
        props.actionCreateRequestSetter({ agencies: [] });
        props.parentChangeFunction && props.parentChangeFunction();
        props.clearAgencyMarketData();
    }

    return (
        <Layout>
            <Header style={{ backgroundColor: "transparent" }}>
                <Row justify="start">
                    <Col span={8}>
                        <Space>

                            {
                                isLoading || props.isLoading
                                    ?
                                    <Skeleton active />
                                    :
                                    <>
                                        <label>{t("action.create.markets")}</label>
                                        <Radio.Group onChange={(e: RadioChangeEvent) => handleTypeChange(e)} value={props.allMarkets ? props.allMarkets : marketFilterRequest?.allMarkets ? marketFilterRequest.allMarkets : false}>
                                            <Radio value={false}>{t("action.create.choose")}</Radio>
                                            <Radio value={true}>{t("action.create.all")}</Radio>
                                        </Radio.Group>
                                    </>
                            }

                        </Space>
                    </Col>
                </Row>
            </Header>
            <Content >
                <Row>
                    <Col span={24}>
                        {
                            isLoading || props.isLoading
                                ?
                                <>
                                    <Skeleton active />
                                    <Skeleton active />
                                    <Skeleton active />
                                </>
                                :
                                <CustomTransfer
                                    dataSource={data?.body?.data?.map(obj => ({
                                        key: obj.key! ?? "null",
                                        title: obj?.title,
                                        children: obj.children ? obj.children.map(chd => ({
                                            key: `${((obj.key && obj.key.length > 0) ? "" : "null_")}${chd.key!}`,
                                            title: chd?.title,
                                            parent: {
                                                key: `${((obj.key && obj.key.length > 0) ? obj.key : "null")}`,
                                                title: chd?.title,
                                            }
                                        })) : [] as mdlKeyTitlePair
                                    })) as mdlKeyTitlePair[]}
                                    selectedKeys={props.actionPricePair.agencies?.map(x => x.key) as string[]}
                                    onChange={handleTransferChange}
                                    parentChangeStatus={props.parentChangeStatus}
                                    parentChangeFunction={() => { props.parentChangeFunction && props.parentChangeFunction(false)}}
                                />
                        }
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}